import React from 'react';
import { View, Text, StyleSheet, TouchableHighlight } from 'react-native';
import { Small } from '@dbk/ui-text';
import styles from './row.styles';

const PortfolioPositionRow = (props) => {
  return (
    <TouchableHighlight onPress={() => props.selectedRow(props)}>
      <View style={styles.container}>
        <Text style={styles.portfolioText}>
          <Small secondary>{props.pfId}</Small>
        </Text>
        <Text style={styles.text}>
          <Small secondary>{props.psDesc}</Small>
        </Text>
      </View>
    </TouchableHighlight>
  );
};

export default PortfolioPositionRow;
